import styled from '@emotion/styled';

export const Box = styled.div`
  padding: 1rem;
  box-shadow: 0px 0px 30px #0000001f;
  color: black;
  margin: 2rem 0;
  border-radius: 3px;
`;
